import {useHandleRoutableLink} from "@/assets/js/src/util/composables/useHandleRoutableLink.js";
import {useDismissNotification} from "@/assets/js/src/util/composables/useDismissNotification.js";

export function useExposeNotificationApi() {
    if (typeof window === 'undefined') {
        return
    }

    window.notification = window.notification || {}
    window.notification.dismiss = useDismissNotification().dismissNotification
    window.notification.handleRoutableLink = useHandleRoutableLink().handleRoutableLink
}
